var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSeo = function SvgSeo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.733 20.533c.534-.933.934-2 .934-3.2 0-3.333-2.667-6-6-6-3.334 0-6 2.667-6 6 0 3.334 2.666 6 6 6 1.2 0 2.266-.4 3.2-.933l4.266 4.267L28 24.8l-4.267-4.267zm-5.066.134a3.3 3.3 0 01-3.334-3.334A3.3 3.3 0 0118.667 14 3.3 3.3 0 0122 17.333a3.3 3.3 0 01-3.333 3.334zm-4.667 4v2.666C6.64 27.333.667 21.36.667 14S6.64.667 14 .667c6.453 0 11.827 4.586 13.067 10.666h-2.76c-.854-3.28-3.2-5.96-6.307-7.213v.547c0 1.466-1.2 2.666-2.667 2.666h-2.666V10c0 .733-.6 1.333-1.334 1.333H8.667V14h2.666v4H10l-6.387-6.387c-.173.774-.28 1.56-.28 2.387 0 5.88 4.787 10.667 10.667 10.667z",
    fill: "#005FFF"
  })));
};

export default SvgSeo;